import React from 'react'


//--------------------------------------------------------------------------------------------------
// DATE/TIME METHODS
//
// these all IGNORE the time zone.  We were initially using Luxon for this but the time zone
// interpretation created problems, so these methods were built that ignore time zone
// everything is treated in UTC -- day/month/etc are returned according to UTC


// gets the short english language name of the month for the provided date
export function getMonthShort(date) {
    switch(date.getUTCMonth()) {
      case  0: return "Jan";
      case  1: return "Feb";
      case  2: return "Mar";
      case  3: return "Apr";
      case  4: return "May";
      case  5: return "June";
      case  6: return "July";
      case  7: return "Aug";
      case  8: return "Sept";
      case  9: return "Oct";
      case 10: return "Nov";
      case 11: return "Dec";
      default: return "";
    }
}

// gets the full english language name of the month for the provided date
export function getMonthLong(date) {
    switch(date.getUTCMonth()) {
      case  0: return "January";
      case  1: return "February";
      case  2: return "March";
      case  3: return "April";
      case  4: return "May";
      case  5: return "June";
      case  6: return "July";
      case  7: return "August";
      case  8: return "September";
      case  9: return "October";
      case 10: return "November";
      case 11: return "December";
      default: return "";
    }
}

// gets the english language name of the weekday for the provided date
export function getWeekdayLong(date) {
    switch(date.getUTCDay()) {
      case  0: return "Sunday";
      case  1: return "Monday";
      case  2: return "Tuesday";
      case  3: return "Wednesday";
      case  4: return "Thursday";
      case  5: return "Friday";
      case  6: return "Saturday";
      default: return "";
    }
}

// for consistency, i'm providing this method, so the caller can use this package for all of their 
// conversions without thinking about specifics
export function getDate(date) {
  return date.getUTCDate()
}

